import React from "react";
import DeviceManager from "./devicemanager.svg";

function DeviceManagerIcon() {
  return <img src={DeviceManager} alt="DeviceManager Icon" />;
}

export default DeviceManagerIcon;
